import { Box, Typography } from "@mui/material";
import React from "react";

import DownArrow from "../../../../../../styles/svg/downArrow.svg";
import { truncateText } from "../../../../../../utils";
import ChangeBoardToDifferentWorkflow from "./ChangeBoardToDifferentWorkflow.js";
import "./ChangeBoardToDifferentWorkflow.scss";
import CustomMenu from "../../../../../../components/Menu/index.js";
import CustomMenuItem from "../../../../../../components/Menu/CustomMenuItem.js";
import { CustomButton } from "../../../../../../components/Button/Button.js";
import { useChangeBoardState } from "./hooks/useChangeBoardState";
function ChangeBoard({ cardId, card }) {
  const {
    anchorEl,
    boardData,
    currentBoardLabel,
    filteredBoards,
    handleAnchorClick,
    handleDialogClose,
    handleMenuClose,
    handleSelectBoard,
    isDialogOpen,
    isMobile,
    open,
    selectedTargetBoard,
    targetBoardLabel,
  } = useChangeBoardState(card);
  const currentWorkflowStepId = boardData?.workflow_step_id;
  const isTodo = boardData?.is_todo;
  const boardId = boardData?.board?.board_id;
  const currentworkflow_id = boardData?.board?.workflow_id;

  return (
    <>
      {isDialogOpen && selectedTargetBoard && (
        <ChangeBoardToDifferentWorkflow
          isTodo={isTodo}
          open={isDialogOpen}
          close={handleDialogClose}
          currentBoardName={currentBoardLabel}
          targetBoardName={targetBoardLabel}
          card={card}
          workflowId={selectedTargetBoard?.workflow_id}
          cardId={cardId}
          targetBoardId={selectedTargetBoard?.board_id}
          currentBoardWorkflowId={currentworkflow_id}
          currentWorkflowStepId={currentWorkflowStepId}
        />
      )}
      {isMobile ? (
        <div className="mt-2">
          <p className="filter-text">Select Target board :</p>

          <Box
            className={"workflow_steps_cont"}
            maxHeight={165}
            overflow={"auto"}
            minHeight={100}
          >
            {filteredBoards?.map((board) => {
              return (
                <Typography
                  key={`change-board-${board?.board_id}`}
                  className={`workflow_steps change-board-bg ${
                    board.board_id == boardId ? "change-board-bg" : ""
                  }`}
                  onClick={() => handleSelectBoard(board)}
                >
                  {truncateText(board.board_name, 26)}
                </Typography>
              );
            })}
          </Box>
        </div>
      ) : (
        <div className="mr-2">
          <CustomButton
            variant="outlined"
            color="primary"
            id="epics-board-dropdown"
            aria-haspopup="true"
            onClick={handleAnchorClick}
            endIcon={<img src={DownArrow} alt="arrow" />}
            className="white-button change-board-btn "
          >
            <p className="header-action-button-text mr-1">Change Board</p>
          </CustomButton>
          <CustomMenu
            id="user-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            className="assign-board-owner-list"
          >
            {filteredBoards?.map((board) => {
              return (
                <CustomMenuItem
                  key={`board-list-my-task-${board?.board_id}`}
                  className="custom-border"
                  onClick={() => handleSelectBoard(board)}
                >
                  <p className="board-name-filter">
                    {truncateText(board.board_name, 26)}
                  </p>
                </CustomMenuItem>
              );
            })}
          </CustomMenu>
        </div>
      )}
    </>
  );
}

const isChangeBoard = (prevProps, nextProps) => {
  const prevCardData = prevProps?.card?.data?.data?.responseData || prevProps?.card || {};
  const nextCardData = nextProps?.card?.data?.data?.responseData || nextProps?.card || {};

  const {
    workflow_step_id: prevWorkflowStepId,
    board: {
      board_id: prevBoardId,
      board_name: prevBoardName,
      workflow_id: prevWorkflowId,
    } = {},
  } = prevCardData;

  const {
    workflow_step_id: nextWorkflowStepId,
    board: {
      board_id: nextBoardId,
      board_name: nextBoardName,
      workflow_id: nextWorkflowId,
    } = {},
  } = nextCardData;

  // Compare all relevant props
  return (
    prevProps.cardId === nextProps.cardId &&
    prevWorkflowStepId === nextWorkflowStepId &&
    prevBoardId === nextBoardId &&
    prevBoardName === nextBoardName &&
    prevWorkflowId === nextWorkflowId
  );
};
export default React.memo(ChangeBoard, isChangeBoard);
